var _mask, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkspaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "addd",
    height: 16,
    maskUnits: "userSpaceOnUse",
    width: 16,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    fill: "#f0f0f0",
    r: 8
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    fill: "#ebebeb",
    r: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#addd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.33366 9.40734v-6.074l7.33334 4v9.33336h-12.00001v-9.33336z",
    fill: "#a9a7a7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceIcon);
export default __webpack_public_path__ + "static/media/workspaceIcon.464bb23db1d25e8b7c3102f426fe9a83.svg";
export { ForwardRef as ReactComponent };